const i18nPath = {
  dictionary: 'dictionary:views.dictionary.translations',
  global: 'views.global',
  local: 'local:views.market',
  globalVariant: 'local:views.market.global.view',
  homepage: 'homepage:views.employeesHomepage',
  cookies: 'cookies-list:views.cookiesList',
  master: 'master:views.masterPage',
  policyPages: 'local:views.market.policyPages',
  speakUp: 'speakUp:route'
};

export { i18nPath };
